<template>
  <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop">
            <close />
          </a>
        </div>
        <div class="corner-top"></div>
        <div class="exists_icon">
          <LOGO />
        </div>
        <div class="pop_frame">
          <h2 class="title25" style="margin-top:20px;">היי, בעגלה שלך כבר יש מוצרים...
מה לעשות איתם?</h2>
          <div class="text"></div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="addToCurrentCart">הוספת המוצרים לעגלה הקיימת</a>
          </div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="addToCart">מחיקת עגלה והוספת המוצרים</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import close from "../../assets/img/close.svg";
import LOGO from "../../assets/img/carmella.svg";
import { mapActions } from "vuex";
export default {
  props: ["order"],
  data() {
    return {};
  },
  methods: {
    ...mapActions(["getProductById", "updateCart", "clarCart"]),
    addToCurrentCart() {
      this.order.items.map(product => {
        this.updateCart([product,true]);
      });
      this.$root.$emit("orderCopy");

      if (this.$store.state.outOfStockCart.length > 0) {
        this.$modal.show("not-exist");
      }
      this.closePop();
      this.openCart();
    },
    openCart() {
      setTimeout(() => {
        $(".cart").fadeIn(100, function() {
          $("body").addClass("noscroll");
          $(".cart_in").animate(
            {
              left: 0
            },
            600
          );
        });
      }, 500);
      this.$router.push({ path: "/" });
    },
    addToCart() {
      this.clarCart();
      this.order.items.map(product => {
        this.updateCart([product,true]);
      });
      this.$root.$emit("orderCopy");

      if (this.$store.state.outOfStockCart.length > 0) {
        this.$modal.show("not-exist");
      }
      this.closePop();
      this.openCart();
    },
    closePop() {
      this.$modal.hide("order-copy");
    }
  },
  components: {
    LOGO,
    close
  }
};
</script>

<style scoped>
.bt_green a {
  width: 320px;
}
</style>
